import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetOptSitesIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetOptSitesIncidents`,
	params: { userId, role }
});

export const GetOptSiteIncidentDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetOptSiteIncidentDetails`,
	params: { userId, tableId }
});

export const GetOptSiteIncidentDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetOptSiteIncidentDropdowns`
});

export const EditOptSiteIncidentDetailsRequest = (optimizationsSiteDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/EditOptSiteIncidentDetails`,
	data: optimizationsSiteDto
});

export const CreateOptSiteIncidentRequest = (optimizationsSiteDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/CreateOptSiteIncident`,
	data: optimizationsSiteDto
});

export const DeleteOptSiteIncidentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/DeleteOptSiteIncident`,
	params: { userId, tableId }
});

export const ExportOptSitesIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/ExportOptSitesIncidents`,
	params: { userId, role }
});

export const GetAutocompleteFieldsRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetAutocompleteFields`,
	params: { siteId }
});

export const GetDriveTestsCitiesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetDriveTestsCities`,
});

export const GetDriveTestsDrivesRequest = (city) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetDriveTestsDrives`,
	params: { city }
});

export const GetDriveTestsDatesRequest = (city, drive) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}OptimizationsSite/GetDriveTestsDates`,
	params: { city, drive }
});

export const GetFailuresRequest = (selectedCity, selectedDates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/GetFailures`,
	data: { selectedCity, selectedDates }
});

export const AddAttachmentRequest = (userId, incidentId, tempFilePath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/AddAttachment`,
	data: { userId, incidentId, tempFilePath }
});

export const DownloadAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/DownloadAttachment`,
	params: { userId, tableId }
});

export const RemoveAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}OptimizationsSite/RemoveAttachment`,
	params: { userId, tableId }
});
